var map = {
	"./1.png": "./src/assets/image/1.png",
	"./11.png": "./src/assets/image/11.png",
	"./2.png": "./src/assets/image/2.png",
	"./22.png": "./src/assets/image/22.png",
	"./3.png": "./src/assets/image/3.png",
	"./33.png": "./src/assets/image/33.png",
	"./4.png": "./src/assets/image/4.png",
	"./44.png": "./src/assets/image/44.png",
	"./55.png": "./src/assets/image/55.png",
	"./66.png": "./src/assets/image/66.png",
	"./77.png": "./src/assets/image/77.png",
	"./88.png": "./src/assets/image/88.png",
	"./99.png": "./src/assets/image/99.png",
	"./WeChat.png": "./src/assets/image/WeChat.png",
	"./active.png": "./src/assets/image/active.png",
	"./bao.png": "./src/assets/image/bao.png",
	"./ding.png": "./src/assets/image/ding.png",
	"./empty-img/no-list-data.png": "./src/assets/image/empty-img/no-list-data.png",
	"./empty-img/no-resource-data.png": "./src/assets/image/empty-img/no-resource-data.png",
	"./empty-img/no-search-data.png": "./src/assets/image/empty-img/no-search-data.png",
	"./empty-img/no-select-data.png": "./src/assets/image/empty-img/no-select-data.png",
	"./fc.png": "./src/assets/image/fc.png",
	"./fileCenter.png": "./src/assets/image/fileCenter.png",
	"./ht.png": "./src/assets/image/ht.png",
	"./huo.png": "./src/assets/image/huo.png",
	"./huodong.png": "./src/assets/image/huodong.png",
	"./icons/city/city_10@2x.png": "./src/assets/image/icons/city/city_10@2x.png",
	"./icons/city/city_1@2x.png": "./src/assets/image/icons/city/city_1@2x.png",
	"./icons/city/city_2@2x.png": "./src/assets/image/icons/city/city_2@2x.png",
	"./icons/city/city_3@2x.png": "./src/assets/image/icons/city/city_3@2x.png",
	"./icons/city/city_4@2x.png": "./src/assets/image/icons/city/city_4@2x.png",
	"./icons/city/city_5@2x.png": "./src/assets/image/icons/city/city_5@2x.png",
	"./icons/city/city_6@2x.png": "./src/assets/image/icons/city/city_6@2x.png",
	"./icons/city/city_7@2x.png": "./src/assets/image/icons/city/city_7@2x.png",
	"./icons/city/city_8@2x.png": "./src/assets/image/icons/city/city_8@2x.png",
	"./icons/city/city_9@2x.png": "./src/assets/image/icons/city/city_9@2x.png",
	"./icons/download@2x.png": "./src/assets/image/icons/download@2x.png",
	"./icons/supplier/supplier_1@2x.png": "./src/assets/image/icons/supplier/supplier_1@2x.png",
	"./icons/supplier/supplier_2@2x.png": "./src/assets/image/icons/supplier/supplier_2@2x.png",
	"./icons/supplier/supplier_3@2x.png": "./src/assets/image/icons/supplier/supplier_3@2x.png",
	"./icons/supplier/supplier_4@2x.png": "./src/assets/image/icons/supplier/supplier_4@2x.png",
	"./icons/supplier/supplier_5@2x.png": "./src/assets/image/icons/supplier/supplier_5@2x.png",
	"./icons/supplier/supplier_6@2x.png": "./src/assets/image/icons/supplier/supplier_6@2x.png",
	"./icons/supplier/supplier_7@2x.png": "./src/assets/image/icons/supplier/supplier_7@2x.png",
	"./jhdgl.png": "./src/assets/image/jhdgl.png",
	"./line.png": "./src/assets/image/line.png",
	"./logao.png": "./src/assets/image/logao.png",
	"./login.jpg": "./src/assets/image/login.jpg",
	"./member.png": "./src/assets/image/member.png",
	"./money-to-review.png": "./src/assets/image/money-to-review.png",
	"./my.png": "./src/assets/image/my.png",
	"./operationCenter.png": "./src/assets/image/operationCenter.png",
	"./quan.png": "./src/assets/image/quan.png",
	"./quanxian.png": "./src/assets/image/quanxian.png",
	"./report.png": "./src/assets/image/report.png",
	"./setPit.png": "./src/assets/image/setPit.png",
	"./shou.png": "./src/assets/image/shou.png",
	"./si.png": "./src/assets/image/si.png",
	"./sug.png": "./src/assets/image/sug.png",
	"./thddy.png": "./src/assets/image/thddy.png",
	"./thdhx.png": "./src/assets/image/thdhx.png",
	"./tip.png": "./src/assets/image/tip.png",
	"./tongji.png": "./src/assets/image/tongji.png",
	"./tp.png": "./src/assets/image/tp.png",
	"./tui.png": "./src/assets/image/tui.png",
	"./xstg.png": "./src/assets/image/xstg.png",
	"./zhifu.png": "./src/assets/image/zhifu.png",
	"./zhuangchedan.png": "./src/assets/image/zhuangchedan.png",
	"./zhuangchedayin.png": "./src/assets/image/zhuangchedayin.png",
	"./zhuanghchefuhe.png": "./src/assets/image/zhuanghchefuhe.png",
	"./zicai.jpg": "./src/assets/image/zicai.jpg",
	"./zicai.png": "./src/assets/image/zicai.png",
	"./zx.png": "./src/assets/image/zx.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/image sync recursive ^\\.\\/.*$";